import React, { useState, useEffect } from 'react';
import { Link, useParams, useSearchParams, useNavigate } from 'react-router-dom';
import Layout from '../../components/global/layout';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import './profile.scss'
import methodModel from '../../methods/methods';
import { useSelector } from 'react-redux';
import environment from '../../environment';
import { LiaUserSolid } from 'react-icons/lia';
import { MdOutlineEmail, MdOutlinePhone, MdOutlineWork } from 'react-icons/md';
import { RiUserShared2Line } from 'react-icons/ri';
import { FaLinkedin, FaBuilding, FaGlobe } from 'react-icons/fa';
import { PiCertificate } from 'react-icons/pi';
import { BsFileText, BsClock } from 'react-icons/bs';


const Profile = () => {

  const navigate = useNavigate();
  const loggedInUser = useSelector((state: any) => state.user);
  const { id: routeId } = useParams();
  const [searchParams] = useSearchParams();
  const groupId = searchParams.get('groupId');
  const fromGraph = searchParams.get('from') === 'graph';
  const isOtherUser = !!routeId && routeId !== loggedInUser?._id;
  const isGroupLeader = (() => {
    if (!groupId || !loggedInUser?.groups) return false;
    const group = loggedInUser.groups.find((g: any) => {
      const gid = g.groupId?._id || g.groupId;
      return gid === groupId && g.status === 'active';
    });
    if (!group) return false;
    const roleId = group.customerRole?._id || group.customerRole;
    return environment.groupLeaderRoleIds.includes(roleId);
  })();

  const [data, setData]: any = useState<any>(null);
  const [certName, setCertName] = useState('');

  const formatPhone = (num: string) => {
    const digits = num.replace(/\D/g, '');
    if (digits.length === 11 && digits.startsWith('1')) {
      return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    }
    if (digits.length === 10) {
      return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return `+${digits}`;
  };

  useEffect(() => {
    if (!isOtherUser) {
      setData(null);
      return;
    }
    loader(true);
    ApiClient.get(`api/user/detail`, { id: routeId }).then((res: any) => {
      if (res?.success) setData(res.data);
      loader(false);
    });
  }, [routeId, isOtherUser]);

  useEffect(() => {
    const certId = (isOtherUser ? data : loggedInUser)?.certification;
    if (certId) {
      ApiClient.get('api/certificate/list', { status: 'active' }).then((res: any) => {
        if (res?.success) {
          const cert = res.data?.find((c: any) => c._id === certId || c.id === certId);
          setCertName(cert?.name || '');
        }
      });
    } else {
      setCertName('');
    }
  }, [data, isOtherUser]);

  const user: any = isOtherUser ? (data || {}) : loggedInUser;
  const canEdit = !isOtherUser || isGroupLeader;

 

  
  return (
    <Layout>


      <div className='wrapper_section'>
        {isOtherUser && (
          <button
            onClick={() => fromGraph ? navigate('/testimonials?view=graph') : navigate(-1)}
            className="mb-4 flex items-center gap-1.5 text-sm text-gray-600 hover:text-gray-900 transition-colors"
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/></svg>
            Back
          </button>
        )}
        <div className='flex items-center  justify-between'>
          <h3 className=' text-lg lg:text-2xl font-semibold text-[#111827]'>
            {isOtherUser ? (user?.fullName ? `${user.fullName}'s Profile` : 'Profile') : 'Basic Information'}
          </h3>
          {canEdit && (
            <Link to={isOtherUser ? `/user-profile/${routeId}/edit` : '/profile/edit'} className="px-2 lg:!px-4 text-sm font-normal bg-orange-500 hover:bg-orange-700 text-white h-10 flex items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed">

              <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path></svg>
              Edit Profile

            </Link>
          )}
        </div>

        <div className='inner_part mt-3 md:mt-8 p-6 shadow-box overflow-hidden rounded-lg bg-white'>
          <div className='grid items-start grid-cols-12 gap-4'>

            <div className='col-span-12 md:col-span-6 lg:col-span-6 2xl:col-span-4  h-full pr-4 md:border-r border-dashed border-primary'>
              <div className='flex flex-col items-center gap-4'>
                <div className=''>
                  <img src={methodModel.userImg(user && user.image)} className="h-32 w-32 rounded-md mx-auto object-cover" />
                </div>
                <div className='flex flex-col gap-y-4 bg-gray-50 p-4 rounded-lg w-full'>
                    <div className='border-gray-200 pb-2 border-b text-gray-700 flex items-center  justify-between  gap-2'>
                        <p className='text-md flex items-center gap-2 text-black'>  <LiaUserSolid className='text-xl' /> Name:</p>
                        <span className='firstc text-md text-gray-800'>{user && user.fullName}</span>
                    </div>

                    {user?.profession && (
                      <div className='border-gray-200 pb-2 border-b text-gray-700 flex items-center justify-between gap-2'>
                        <p className='text-md flex items-center gap-2 text-black'><MdOutlineWork className='text-xl' /> Profession:</p>
                        <span className='firstc text-md text-gray-800'>{user.profession}</span>
                      </div>
                    )}

                    <div className='border-gray-200 pb-2 border-b text-gray-700 flex flex-col gap-1'>
                        <p className='text-md flex items-center gap-2 text-black'>  <MdOutlineEmail className='text-xl' /> Email:</p>
                        <span className='text-sm text-gray-800 break-all pl-7'>{user && user.email}</span>
                    </div>

                    {user?.secondaryEmail && (
                      <div className='border-gray-200 pb-2 border-b text-gray-700 flex flex-col gap-1'>
                        <p className='text-md flex items-center gap-2 text-black'><MdOutlineEmail className='text-xl' /> Secondary Email:</p>
                        <span className='text-sm text-gray-800 break-all pl-7'>{user.secondaryEmail}</span>
                      </div>
                    )}

                    <div className='border-gray-200 pb-2 border-b text-gray-700 flex items-center  justify-between  gap-2'>
                        <p className='text-md flex items-center gap-2 text-black'>  <MdOutlinePhone className='text-xl' /> Phone No:</p>
                        <span className='firstc text-md text-gray-800'>{user.mobileNo ? formatPhone(String(user.mobileNo)) : 'N/A'}</span>
                    </div>

                    {user?.company && (
                      <div className='border-gray-200 pb-2 border-b text-gray-700 flex items-center justify-between gap-2'>
                        <p className='text-md flex items-center gap-2 text-black'><FaBuilding className='text-xl' /> Company:</p>
                        <span className='text-md text-gray-800'>{user.company}</span>
                      </div>
                    )}

                    {user?.companyUrl && (
                      <div className='border-gray-200 pb-2 border-b text-gray-700 flex flex-col gap-1'>
                        <p className='text-md flex items-center gap-2 text-black'><FaGlobe className='text-xl' /> Company URL:</p>
                        <a href={user.companyUrl.startsWith('http') ? user.companyUrl : `https://${user.companyUrl}`} target="_blank" rel="noopener noreferrer" className='text-sm text-blue-600 hover:underline break-all pl-7'>{user.companyUrl}</a>
                      </div>
                    )}

                    {user?.timezone && (
                      <div className='border-gray-200 pb-2 border-b text-gray-700 flex items-center justify-between gap-2'>
                        <p className='text-md flex items-center gap-2 text-black'><BsClock className='text-xl' /> Timezone:</p>
                        <span className='text-md text-gray-800'>{user.timezone}</span>
                      </div>
                    )}

                    {(user?.linkedInUrl || user?.certification || user?.aboutUs) && (
                      <>
                        <p className='text-md font-semibold text-black pt-2'>Public Profile Info</p>

                        {user?.linkedInUrl && (
                          <div className='border-gray-200 pb-2 border-b text-gray-700 flex flex-col gap-1'>
                            <p className='text-md flex items-center gap-2 text-black'><FaLinkedin className='text-xl' /> LinkedIn:</p>
                            <a href={user.linkedInUrl.startsWith('http') ? user.linkedInUrl : `https://${user.linkedInUrl}`} target="_blank" rel="noopener noreferrer" className='text-sm text-blue-600 hover:underline break-all pl-7'>{user.linkedInUrl}</a>
                          </div>
                        )}

                        {certName && (
                          <div className='border-gray-200 pb-2 border-b text-gray-700 flex items-center justify-between gap-2'>
                            <p className='text-md flex items-center gap-2 text-black'><PiCertificate className='text-xl' /> Certification:</p>
                            <span className='text-md text-gray-800'>{certName}</span>
                          </div>
                        )}

                        {user?.aboutUs && (
                          <div className='border-gray-200 pb-2 border-b text-gray-700 flex flex-col gap-1'>
                            <p className='text-md flex items-center gap-2 text-black'><BsFileText className='text-xl' /> Short Bio:</p>
                            <span className='text-sm text-gray-800 pl-7'>{user.aboutUs}</span>
                          </div>
                        )}
                      </>
                    )}


                </div>
              </div>
            </div>

            <div className='col-span-12 md:col-span-6 lg:col-span-6 2xl:col-span-8 '>
              <div className='mt-2 '>

                <p className='mb-4 text-xl font-medium'>All Groups</p>
                <div className='overflow-auto'>
                  <table className='w-full'>
                    <thead className='border-y border-[#EAECF0]'>
                      <tr className='border-y border-[#EAECF0]'>
                        <th className='text-black !border-l font-normal text-md !border border-[#EAECF0] px-3 py-2  text-left bg-[#F7FAFF] capitalize'>Group</th>
                        <th className='text-black !border-l font-normal text-md !border border-[#EAECF0] px-3 py-2  text-left bg-[#F7FAFF] capitalize'>Role</th>

                      </tr>

                    </thead>
                    <tbody>
                      {user?.groups?.filter((g: any) => g.status === 'active').map((g: any, i: number) => {
                        const groupName = g.groupId?.name || '--';
                        const cmLabel = loggedInUser?.connectMeetLabel || 'ConnectMeet';
                        const tyLabel = loggedInUser?.testimonialLabel || 'Thank Yous';
                        let roleName = g.customerRole?.name || g.role || '--';
                        if (roleName === 'ConnectMeet Manager') roleName = `${cmLabel} Manager`;
                        if (roleName === 'Thank You Tracker') roleName = `${tyLabel} Tracker`;
                        return (
                          <tr key={i}>
                            <td className='text-[#82838B] !border-l font-normal text-sm !border border-[#EAECF0] px-3 text-left bg-[#F7FAFF] !py-2 capitalize'>{groupName}</td>
                            <td className='text-[#82838B] !border-l font-normal text-sm !border border-[#EAECF0] px-3 text-left bg-[#F7FAFF] !py-2 capitalize'>{roleName}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

              </div>

            </div>






          </div>




        </div>
      </div>



    </Layout>
  );
};

export default Profile;